// 上传任务队列
export class Queue {
  static instance: null | Queue;
  // 每个workspace最多同时上传文件的数量
  static parallel = 2;
  // 总任务池
  private taskPool: ITaskPipe = {};
  // 获取队列的实例
  static getInstance() {
    if (!Queue.instance) {
      Queue.instance = new Queue();
    }
    return Queue.instance;
  }

  // 添加任务到总队列中
  public add(workspace: string, task: taskType) {
    const { taskPipe } = this.getWorkspaceTasks(workspace);
    taskPipe.push(task);
  }

  // 添加任务到缓存池中
  private addCache(workspace: string) {
    const { taskPipe, cachePipe } = this.getWorkspaceTasks(workspace);
    if (!taskPipe.length) return;

    while (taskPipe.length && cachePipe.length < Queue.parallel) {
      const task = taskPipe.shift();
      if (task) {
        cachePipe.push(task);
      }
    }
  }

  // 开始执行任务
  public async post(workspace: string) {
    // 添加缓存池
    this.addCache(workspace);
    const { cachePipe } = this.taskPool[workspace];

    // 如果已经添加完还没有任务的话说明没有任务了
    if (!cachePipe.length) return;
    const length = cachePipe.length;
    for (let i = 0; i < length; i++) {
      try {
        this.run(workspace);
      } catch (error) {}
    }
  }

  // 每个任务实际执行的调用
  public async run(workspace: string) {
    const { cachePipe } = this.taskPool[workspace];
    const task = cachePipe.shift();
    if (task) {
      await task.task();
      this.addCache(workspace);
      this.run(workspace);
    } else {
      //  没有任务的时候再做一次check
      this.addCache(workspace);
      const { cachePipe } = this.taskPool[workspace];
      if (!cachePipe.length) return;
      this.run(workspace);
    }
  }

  // 删除当前队列中的某个任务
  public async delete(workspace: string, id: string) {
    const { cachePipe, taskPipe } = this.taskPool[workspace];
    const index = cachePipe.findIndex((item) => {
      return item.id === id;
    });
    if (index !== -1) {
      cachePipe.splice(index, 1);
      return;
    }

    const taskIndex = taskPipe.findIndex((item) => {
      return item.id === id;
    });
    if (taskIndex !== -1) {
      taskPipe.splice(taskIndex, 1);
      return;
    }
  }

  // 获取当前workspace中的某个任务
  private getWorkspaceTasks = (workspace: string) => {
    if (!this.taskPool?.[workspace]) {
      this.taskPool[workspace] = {
        taskPipe: [],
        cachePipe: [],
      };
    }

    return this.taskPool[workspace];
  };
}

type taskType = {
  id: string;
  task: () => Promise<any>;
};
interface ITaskPipe {
  [propname: string]: {
    cachePipe: taskType[];
    taskPipe: taskType[];
  };
}
